import { DateTime } from 'luxon'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function formatPhone(value: string | null | undefined): string {
  if (!value) return ''
  try {
    const parsed = parsePhoneNumberFromString(value)
    if (!parsed) return value
    return parsed.country === 'US' || parsed.country === 'CA'
      ? parsed.formatNational()
      : parsed.formatInternational()
  } catch {
    return value
  }
}

export function formatDate(iso: string, tz?: string | null) {
  try {
    const dt = DateTime.fromISO(iso, { zone: tz || 'utc' })
    return dt.toFormat('MM/dd/yyyy')
  } catch {
    return iso
  }
}

export function formatRelativeTime(iso: string): string {
  try {
    const then = new Date(iso).getTime()
    const now = Date.now()
    const diffSec = Math.round((now - then) / 1000)
    if (diffSec < 60) return 'just now'
    const diffMin = Math.round(diffSec / 60)
    if (diffMin < 60) return `${diffMin}m ago`
    const diffHr = Math.round(diffMin / 60)
    if (diffHr < 24) return `${diffHr}h ago`
    const diffDay = Math.round(diffHr / 24)
    if (diffDay < 30) return `${diffDay}d ago`
    return new Date(iso).toISOString().slice(0, 10)
  } catch {
    return iso
  }
}
